import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useBlocker, useParams } from 'react-router-dom';
import {
  AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, useDisclosure,
} from '@chakra-ui/react';
import { getForm, setTemplate } from '../../Components/FormSetup/formSlice';
import { useGetTemplateDraftQuery } from '../../Services/templates';

const TemplateLayout = () => {
  const { templateId } = useParams();
  const { isFetching, data: template } = useGetTemplateDraftQuery(templateId);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const { dirty } = useSelector(getForm);
  const cancelRef = useRef();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => {
      console.log(nextLocation);
      if (nextLocation.pathname.endsWith('/preview') || nextLocation.pathname.endsWith('/edit')) return false;
      return dirty && currentLocation.pathname !== nextLocation.pathname;
    },
  );
  useEffect(() => {
    if (!isFetching) {
      dispatch(setTemplate(template));
    }
  }, [isFetching, template?.id]);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      onOpen();
    }
  }, [blocker.state]);

  const handleCancel = () => {
    blocker.reset();
    onClose();
  };

  const handleContinue = () => {
    blocker.proceed();
    onClose();
  };

  return (
    <>
      <Outlet />
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Your changes are not save
            </AlertDialogHeader>

            <AlertDialogBody>
              If you continue your changes will be lost
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={handleCancel} size="sm">
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleContinue} ml={3} size="sm">
                Continue
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default TemplateLayout;
